import { Component, OnInit, Inject } from '@angular/core';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';

import { DialogService } from '../../../../shared/services/dialog.service';
import { DialogComponent } from '../../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../../components/form/label/label.component';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Utility } from '../../../../common/utility';
import { FormMessageComponent } from '../../../../components/form/message/message.component';
import { AppConstants } from '../../../../shared/constants/constants';
import { AppMessages } from '../../../../shared/constants/messages';
import { ValidationService } from '../../../../shared/services/validation.service';

import { Page } from '../../../../models/list/page.model';
import { GroupWaitingService } from './group.service';
import { GroupWaitingModel } from '../../../../models/waiting-room/group-waiting.model';
import { ConsultationType, ConsultationValue } from '../../../../models/consultation/consultation.model';
import { IndividualWaitingModel } from '../../../../models/waiting-room/individual-waiting.model';

@Component({
  selector: 'create-group-popup',
  templateUrl: 'group-popup.component.html',
  providers: [GroupWaitingService]
})
export class CreateGroupPopupComponent implements OnInit {
  public consultationType = ConsultationType;
  public isExternal = false; //paging table list in FE
  public addPatientForm: FormGroup;
  public groupForm: FormGroup;
  public title = 'Create';
  public page = new Page();
  public dataRow = new Array<IndividualWaitingModel>();
  public dataListPatientAdd = new Array<IndividualWaitingModel>();
  public groupWaitingModel = new GroupWaitingModel();
  public dataMessage = {
    emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
    totalMessage: AppMessages.list.total
  };
  public appConstants = AppConstants;
  public customClasses = AppConstants.table.footerClasses;
  public isCreateSuccess = false;
  public dataPaymentTerm = [];

  constructor(
    public utility: Utility,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    public groupWaitingService: GroupWaitingService,
    public dialogRef: MdDialogRef<CreateGroupPopupComponent>,
    @Inject(MD_DIALOG_DATA) public data: any
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.page.size = 5;
    this.setPage({ offset: 0 });
    this.initSelectPatientList();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.dataRow = JSON.parse(JSON.stringify(this.data.patientMembers));
    this.page.totalElements = this.dataRow.length;
    this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);

    this.groupForm.controls['patientMembers'].setValue(this.dataRow);
    this.groupWaitingService.getDataPaymentTerm().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.dataPaymentTerm = data;
          // Display list of options in specific order “Group 15 day credit”, “Group members paying individually”
          this.dataPaymentTerm.splice(this.dataPaymentTerm.indexOf('30 days from invoices date'), 1);
        }
      }
    );
  }

  createForm() {
    this.groupForm = this.formBuilder.group({
      groupREF: '',
      groupName: ['', [Validators.required, ValidationService.isSpecialCharacters]],
      contact: ['', [Validators.required, ValidationService.isSpecialCharacters]],
      address: ['', [Validators.required]],
      email: ['', [Validators.required, ValidationService.isValidEmail]],
      phone: ['', [Validators.required]],
      description: '',
      patientMembers: [this.dataRow],
      paymentTerm: [null, [Validators.required]]
    });

    this.addPatientForm = this.formBuilder.group({
      patientId: [null, [Validators.required]]
    });

  }
  initSelectPatientList() {
    // call API to get data
    // this.dataListPatientAdd = this.groupWaitingService.getPatientAddList();
    this.groupWaitingService.getPatientAddList().subscribe(
      (result) => {
        const data = result.json();
        this.dataListPatientAdd = data;
        // data.forEach(element => {
        //   let patient = new IndividualWaitingModel();
        //   patient.patientREF = element.patientREF;
        //   patient.name = element.name;
        //   patient.dateOfBirth = element.dateOfBirth;
        //   patient.userId = element.id;
        //   patient.id = element.id;
        //   this.dataListPatientAdd.push(patient);
        // });
        // remove patient who is exist in selected patient array
        this.groupWaitingService.addPatientToTable(this.dataRow, this.dataListPatientAdd);
      }
    );
  }

  onCloseDialog() {
    this.dialogRef.close(this.isCreateSuccess);
  }

  onSubmit() {
    if (this.groupForm.dirty && this.groupForm.valid) {
      // call API to create group

      this.groupWaitingService.createGroupWaitting(this.groupForm.value).subscribe(
        (result) => {
          if (result) {
            this.isCreateSuccess = true;
            this.onCloseDialog();
            // open success popup
            this.dialogService.openSuccessDialog({
              message: AppMessages.consultant.createMessage
            });
          }
        }
      );
    }
  }

  onAddItem(event) {
    this.addPatientForm.controls['patientId'].markAsTouched();
    const patientId = this.addPatientForm.controls['patientId'].value;
    // no patient is selected
    if (patientId !== 'null' && patientId !== undefined && patientId !== null && this.addPatientForm.controls['patientId'].valid) {
      const patientItem = this.dataListPatientAdd.filter(c => c.id === patientId);
      // add patient to patient array
      this.dataRow.push(patientItem[0]);
      // remove patient from select box
      this.groupWaitingService.addPatientToTable([patientItem[0]], this.dataListPatientAdd);
      this.page.totalElements += 1;

      // set patientId null when add success
      this.addPatientForm.controls['patientId'].setValue(null);
      this.addPatientForm.controls['patientId'].markAsUntouched();
    }
  }

  onRemoveItem(userId) {
    const data = {
      message: AppMessages.groupConsultant.removeUserFromCreateGroup,
    };
    this.dialogService.openConfirmationDialog(data).subscribe(result => {
      if (result) {
        //remove user from group
        this.groupWaitingService.removePatientFromTable(this.dataRow, this.dataListPatientAdd, userId);
        this.page.totalElements -= 1;
      }
    });
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group/create-group-popup.component.ts